import { ProjectTemplateModel } from '@sixense/ds-organisations-models';
import { DsExportTemplateResponseInterface } from '../interfaces/ds-export-template-response.interface';

export class DsExportTemplateResponse {
  /**
   *
   */
  projectTemplate: ProjectTemplateModel;

  /**
   * Creates an instance of DsExportTemplateResponse.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsExportTemplateResponseInterface) {
    this.projectTemplate = jsonData.projectTemplate;
  }
}
